// extracted by mini-css-extract-plugin
export var activeMediaTab = "style-mod--active-media-tab--8df3e";
export var buttonActive = "style-mod--button-active--2d170";
export var buttonClicked = "style-mod--button-clicked--982f9";
export var cardButton = "style-mod--card-button--15016";
export var coloredMediaTab = "style-mod--colored-media-tab--dd22a";
export var coloredMediaTabButtonsItem = "style-mod--colored-media-tab-buttons-item--2c8c7";
export var coloredMediaTabContainer = "style-mod--colored-media-tab-container--65d6f";
export var coloredMediaTabText = "style-mod--colored-media-tab-text--66fec";
export var coloredMediaTabs = "style-mod--colored-media-tabs--c1831";
export var coloredTabActive = "style-mod--colored-tab-active--340a6";
export var fullOpacityImage = "style-mod--full-opacity-image--b7199";
export var mainTitle = "style-mod--main-title--1542e";
export var mediaTab = "style-mod--media-tab--f2049";
export var mediaTabButtons = "style-mod--media-tab-buttons--8c006";
export var mediaTabButtonsContainer = "style-mod--media-tab-buttons-container--56671";
export var mediaTabButtonsDesktop = "style-mod--media-tab-buttons-desktop--9ff0b";
export var mediaTabButtonsItem = "style-mod--media-tab-buttons-item--864c4";
export var mediaTabButtonsMobile = "style-mod--media-tab-buttons-mobile--7dc7b";
export var mediaTabCnt = "style-mod--media-tab-cnt--9e46d";
export var mediaTabContainer = "style-mod--media-tab-container--98f8e";
export var mediaTabImage = "style-mod--media-tab-image--81f8d";
export var mediaTabItem = "style-mod--media-tab-item--8826b";
export var mediaTabItemReverse = "style-mod--media-tab-item-reverse--d8c8a";
export var mediaTabText = "style-mod--media-tab-text--cbd8a";
export var mediaTabVideo = "style-mod--media-tab-video--74cba";
export var mediaTabsMainTitle = "style-mod--media-tabs-main-title--5d657";
export var notActiveButton = "style-mod--not-active-button--b8ccb";
export var notActiveColoredTab = "style-mod--not-active-colored-tab--1bbd3";
export var paddedImage = "style-mod--padded-image--784b1";
export var prodImage = "style-mod--prod-image--a36a4";
export var productsMediaItem = "style-mod--products-media-item--2d6cc";
export var productsMediaTab = "style-mod--products-media-tab--d2e4a";
export var productsMediaTabButtons = "style-mod--products-media-tab-buttons--443fa";
export var responsiveContainer = "style-mod--responsive-container--d97e2";
export var selectedMediaItem = "style-mod--selected-media-item--979b1";
export var tabActive = "style-mod--tab-active--acbb9";
export var transparentImage = "style-mod--transparent-image--59d93";